import React from "react";

function Highlights(props) {

  return (
    <>
      <aside className="highlights">
        <div className="highlights-title-container text-center d-flex justify-content-between">
          <div className="highlights-title">
            <h4>Highlights</h4>
          </div>
          <img src="/images/highlights.png" className="highlights-logo"></img>
        </div>
        <div className="widget-body">

          <div className="booktext" dangerouslySetInnerHTML={{ __html: props.workshop.highlights }} />

        </div>
      </aside>
    </>
  );
}

export default Highlights;
